import React from "react";
import { showDialogAsync } from "../../dialog-queue";
import { RejectedPhotosDialog } from "./rejected-photos-dialog";

export const showRejectedPhotosDialogAsync = (
	code: string,
	formatMessage: (msg: string) => string,
) =>
	showDialogAsync<undefined | false>(
		({ resolve }, { isOpen }) => (
			<RejectedPhotosDialog
				code={code}
				formatMessage={formatMessage}
				open={isOpen}
				onClose={resolve}
			/>
		),
		{
			allowOther: true,
		},
	);
